import demandService from '@/service/demand';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';

// 获取人均福利分布

const moDemandPdf = observable({
  trendQuarter: <any>[],
  cityRecruitList: <any>[],
  companyIndsutryListTime: <any>[],
  companyRankList: <any>[],
  hotListTop30: <any>[],
  Xvlaue: 'axis_amount',
  Yvlaue: 'axis_amount_change',
  cityTime: '近12个月',
  companyTime: '近1个月',
  hotRoleTime: '近12个月',
});

// 获取招聘数据

const getTrendQuarter = action(async () => {
  const params = {
    industry: moIndex.industry.name,
  };
  const trendQuarter = await demandService.getIndustryTrendQuarter(params);
  runInAction(() => {
    moDemandPdf.trendQuarter = trendQuarter;
  });
});

// 获取城市数据

const getCityRecruitList = action(async () => {
  const cityList = await demandService.getCityList({ date: moDemandPdf.cityTime });
  runInAction(() => {
    moDemandPdf.cityRecruitList = cityList;
  });
});

// 获取公司数据

const getCompanyIndustryTime = action(async () => {
  const companyIndsutryList = await demandService.getCompanyIndustryTime({ time_type: 'quarter' });
  runInAction(() => {
    moDemandPdf.companyIndsutryListTime = companyIndsutryList;
  });
});

const getCompanyRankList = action(async () => {
  const companyRankList = await demandService.getCompanyRankList({ date: moDemandPdf.companyTime });
  runInAction(() => {
    moDemandPdf.companyRankList = companyRankList;
  });
});

// 获取热门top30

const getRankTop30 = action(async () => {
  const top30 = await demandService.getRankTop30({ time_option: moDemandPdf.hotRoleTime });
  runInAction(() => {
    moDemandPdf.hotListTop30 = top30;
  });
});

// 以下都是切换默认值

const changeCityTime = action((val: any) => {
  runInAction(() => {
    moDemandPdf.cityTime = val;
  });
});

const changeCompanyTime = action((val: any) => {
  runInAction(() => {
    moDemandPdf.companyTime = val;
  });
});

const changeHotRole = action((val: any, x: any, y: any) => {
  runInAction(() => {
    moDemandPdf.hotRoleTime = val;
    moDemandPdf.Xvlaue = x;
    moDemandPdf.Yvlaue = y;
  });
});

const demandInit = action(async () => {

  await Promise.all([
    getTrendQuarter(),
    getCityRecruitList(),
    getCompanyIndustryTime(),
    getCompanyRankList(),
    getRankTop30(),
  ]);
});

export default moDemandPdf;
export { demandInit, changeCityTime, changeCompanyTime, changeHotRole };
